module.exports = __webpack_public_path__ + "1f0b0e591ed6199ba06c1606bca3e925.png";